import { Select } from "@mantine/core";
import {
  IAfterGuiAttachedParams,
  IDoesFilterPassParams,
} from "ag-grid-enterprise";
import { CustomFilterProps, useGridFilter } from "ag-grid-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { getTblDmEmployeeAll } from "../../../service/getSelectApi";

export default ({ model, onModelChange, getValue }: CustomFilterProps) => {
  const refInput = useRef<HTMLInputElement>(null);
  const doesFilterPass = useCallback(
    (params: IDoesFilterPassParams) => {
      const { node } = params;
      const filterText: string = model;
      const value: string = getValue(node).toString().toLowerCase();
      // make sure each word passes separately, ie search for firstname, lastname
      const result = filterText
        .toLowerCase()
        .split(" ")
        .every((filterWord) => value.indexOf(filterWord) >= 0);
      return result;
    },
    [model]
  );

  const afterGuiAttached = useCallback((params?: IAfterGuiAttachedParams) => {
    if (!params || !params.suppressFocus) {
      // Focus the input element for keyboard navigation.
      // Can't do this in an effect,
      // as the component is not recreated when hidden and then shown again
      refInput.current?.focus();
    }
  }, []);

  // register filter handlers with the grid
  useGridFilter({
    doesFilterPass,
    afterGuiAttached,
  });

  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const fetchDataEmp = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      const data = res
        .filter((item) => item.code && item.fullname)
        .map((item) => ({
          label: `${item.code} - ${item.fullname}`,
          value: String(item.code),
        }));
      setDataEmployee(data);
    }
  };

  useEffect(() => {
    fetchDataEmp();
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Select
        searchable
        clearable
        comboboxProps={{
          transitionProps: { transition: "fade-up", duration: 200 },
        }}
        size="xs"
        mt={10}
        data={dataEmployee}
        multiple={true}
        onChange={(value) => {
          onModelChange({
            filter: value === null ? "" : value,
            filterType: "text",
            type: "contains",
          });
        }}
        width={"100%"}
        nothingFoundMessage="Dữ liệu không có !"
      />
    </div>
  );
};
